module.exports = __webpack_public_path__ + "img/fm.3cc045e4.svg";